export default __webpack_public_path__ + "static/media/beer.f33b5d8c.gif";